import { Route } from 'types/route.type';
import CreateProfiles from './components/create-profiles';
import EditProfiles from './components/edit-profiles';
import ListProfiles from './list-profiles';

export const routes: Route[] = [
  {
    path: '/profiles-strategies/profiles',
    component: ListProfiles,
    id: 'profilesStrategies.listProfiles.title',
  },
  {
    path: '/profiles-strategies/profiles/create',
    component: CreateProfiles,
    id: 'profilesStrategies.createProfiles.title',
  },
  {
    path: '/profiles-strategies/profiles/:profileType/:profileId',
    component: EditProfiles,
  },
];
